<template>
  <div v-if="patient">
    <h4 class="py-2" v-if="!viewAction">{{actionType === 'add' ? 'Create' : 'Update'}}  Patient</h4>
    <form @submit.prevent="validateBeforeSubmit">
      <div class="row pb-4">
        <div class="col col-md-6 col-12">
          <div class="form-group">
            <label for="patient-first_name">First Name</label>
            <b-form-input
              v-model="patient.first_name"
              v-validate="'required'"
              :disabled="!isEnableEdit"
              :class="{ danger: errors.has('firstName') }"
              name="firstName"
              type="text"
              placeholder="Enter your first name"
            />
          </div>
        </div>
        <div class="col col-md-6 col-12">
          <div class="form-group">
            <label for="lastName">Last Name</label>
            <b-form-input
              v-model="patient.last_name"
              v-validate="'required'"
              :class="{ danger: errors.has('lastName') }"
              :disabled="!isEnableEdit"
              name="lastName"
              class="col-12"
              placeholder="Enter your last name"
            />
          </div>
        </div>
        <div class="col col-md-6 col-12">
          <div class="form-group">
            <label for="mr_id">MRN Id</label>
            <b-form-input
              v-model="patient.mr_id"
              v-validate="'required'"
              :class="{ danger: errors.has('mrId') }"
              :disabled="!isEnableEdit"
              class="form-control"
              name="mrId"
              placeholder="Enter MRN Id"
            />
          </div>
        </div>
        <div class="col col-md-6 col-12 row m-0 p-0">
          <div class="col col-md-6 col-12">
            <div class="form-group">
              <label for="gender">Gender</label>
              <b-form-select
                v-model="patient.gender"
                v-validate="'required'"
                :disabled="!isEnableEdit"
                :class="{ danger: errors.has('gender') }"
                class="form-control"
                name="gender"
                :options="genders"
              />
            </div>
          </div>
          <div class="col col-md-6 col-12 fl-left">
            <v-date-picker
              :label="`Date of birth`"
              :value="defaultDateFormat(patient.dob)"
              :maxDate="getFormattedDate(new Date())"
              :disabled="!isEnableEdit"
              @onChange="value => (patient.dob = value)"
              v-validate="`required`"
              :className="{ danger: errors.has('dob') }"
              name="dob"
              position="bottom"
            />
          </div>
        </div>
        <div class="col col-md-6 col-12">
          <div class="form-group">
            <label for="email">Email</label>
            <b-form-input
              v-model="patient.email"
              v-validate="'required|email'"
              :class="{ danger: errors.has('email') }"
              :disabled="!isEnableEdit"
              class="form-control"
              name="email"
              placeholder="Enter email"
            />
          </div>
        </div>

        <div class="col col-md-6 col-12">
          <v-mobile-input
            :value="patient.mobile_no"
            :countryCode="patient.country_code"
            v-model="patient.mobile_no"
            :label="`Mobile Number`"
            v-validate="'required'"
            :disabled="!isEnableEdit"
            :className="{ danger: errors.has('mobileNumber') }"
            @onChange="onMobileInputChange"
            name="mobileNumber"
            type="number"
            placeholder="Enter MobileNumber"
          />
          <span class="text-danger" v-if="!isMobileNumberValid"
            ><small>The mobileNumber must be a valid mobile number</small></span
          >
        </div>
        <div class="col col-md-6 col-12" />
        <div class="col text-right">
          <b-button type="submit" variant="primary"
            >{{ actionType === "add" ? "Create Patient" : "" }}
            <span v-if="actionType !== 'add' && !isEnableEdit" v-on:click.prevent="isEnableEdit=true">
              Edit Details
            </span>
            <span v-else-if="actionType !== 'add' && isEnableEdit">
              Update
            </span>
          </b-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import VMobileInput from "@/components/baseComponents/BaseMobileInput.vue";
import { mapGetters } from "vuex";

export default {
  name: "CreatePatient",
  components: { VMobileInput },
  data() {
    return {
      isMobileNumberValid: true,
      isEnableEdit: true,
      genders: [
        {
          value: null,
          text: "Select a Gender"
        },
        {
          value: "male",
          text: "Male"
        },
        {
          value: "female",
          text: "Female"
        }
      ]
    };
  },
  props: {
    patient: {
      type: Object,
      default: () => {}
    },
    actionType: {
      type: String
    },
    viewAction: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      templateLoading: "patient/getLoading"
    })
  },
  beforeMount() {
    this.isEnableEdit = this.actionType === "edit" ? false : true;
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        const data = this.patient;
        if (
          result && this.isEnableEdit &&
          (this.patient.mobile_no ||
            (this.patient.user && this.patient.user.mobile_no)) &&
          this.isMobileNumberValid
        ) {
          data.email = data.email.toLowerCase();
          this.$emit("submit", data);
          this.isEnableEdit = this.actionType === "edit" ?  false : true;
        } else {
          this.isEnableEdit = true;
        }
      });
    },
    onMobileInputChange({ isValid, country }, mobileNumber) {
      this.isMobileNumberValid = isValid;
      this.patient.mobile_no = mobileNumber;
      this.patient.country_code = country.dialCode;
    }
  }
};
</script>
